import {
  Grid,
  Button,
  Box,
  Typography,
  FormControlLabel,
  Radio,
  FormControl,
  FormLabel,
  RadioGroup,
  CardMedia,
} from "@mui/material";
import React, { memo, useEffect, useState } from "react";
import ButtonRight from "../../components/BoxRightContent/ButtonRight";
import BoxLeftContent from "../../components/BoxLeftContent/BoxLeftContent";
import clsx from "clsx";
import Configs from "../../constants/Configs";
import DialogCustoms from "../../components/CustomDialog/DialogCustoms";
import DialogCustom from "../../components/CustomDialog/DialogCustoms";
import DialogError from "../../components/CustomDialog/DialogWait";
import {
  getData,
  storeData,
  clearData,
  callChoice,
  getAllStorage,
} from "../../utils/GlobalHelper";
import HeaderRight from "../../components/BoxRightContent/HeaderRight";
import HeaderPage from "../../components/HeaderPage/Index";
import { isMobile } from "react-device-detect";
import Loading from "../../components/loading/loading";
import { makeStyles } from "@mui/styles";
import ScrollBarComponent from "../../components/BoxRightContent/ScrollBarComponent";
import { isEmpty } from "lodash";
import { API_CODE_SUCCESS } from "../../constants/CommonConstant";
import GlobalApi from "../../utils/GlobalApi";
import qs from "qs";
const useStyle = makeStyles({
  textPhone: {
    paddingRight: "5px",
    color: "var(--text-black)",
  },
  title_row: {
    color: "var(--primary)",
    fontFamily: "DB Heavent",
    marginTop: "25px",
    fontSize: "24px",
  },
  textError: {
    fontSize: "16px !important",
    fontFamily: "DB Heavent !important",
    color: "var(--red) !important",
  },
  ndidTable: {
    display: "flex",
    fontFamily: "DB Heavent",
    fontSize: "18px",
    marginBottom: "28px",
    "& div:first-child": {
      width: "40%",
      minWidth: "110px",
      maxWidth: "110px",
      fontWeight: "bold",
      "& img": {
        width: "80%",
      },
    },
    "& div:last-child": { width: "100%" },
  },
});
const NdidInformation = (props) => {
  const classes = useStyle();
  const [isCheck, setIscheck] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalError, setIsModalError] = useState(false);
  const [lang, setLang] = useState(getData("lang"));
  const [modalErrorTitle, setModalErrorTitle] = useState("ขออภัย");
  const [modalErrorDes, setModalErrorDes] = useState(
    "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง",
  );
  const [translations, setTranslations] = useState("");
  const head_token = getData("HeaderManp")
    ? getData("HeaderManp")?.head_token
    : "";
  const [jumpPage, setJumpPage] = useState(false);
  const checkuserinfo = getData("checkuserinfo");
  const questions = getData("questionsAnswer");
  const pageAgree = getData("page_agree");
  const idc = getData("idc");
  const idcAddr = getData("f2_idc_address");
  const curAddr = getData("f2_current_address");
  const workAddr = getData("f2_workplace_address");
  const docAddr = getData("f2_document_address");
  const suit = getData("suitability");
  const status = getData("family_status");
  const childList = getData("childList");
  const career = getData("f3_career");
  const income = getData("f3_source_income");
  const purpose = getData("f3_purpose_invest");
  const asset = getData("f3_asset");
  const ats = getData("f7_ats");
  const bank_ats = getData("f7_bank_ats");
  const summary = getData("passedSummary");
  let snapIdCard = getData("uploadImage");
  let uploadImgSign = getData("uploadImageSign");
  let uploadImageBookBank = getData("uploadImageBookBank");
  const ic = getData("current_ic");

  useEffect(() => {
    checkJumpPage().then((res) => {
      if (res) setJumpPage(true);
    });
  }, []);
  useEffect(() => {
    const translation = getData("Translations");
    if (!isEmpty(translation)) {
      setTranslations(translation);
    } else {
      props.history.push("/");
    }
  }, []);
  const checkJumpPage = async () => {
    var stamp_page = getData("stamp_page");
    // console.log("==stamp_page", stamp_page);
    await getImage();
    let productChoice = false;
    await callChoice(head_token).then((res) => {
      if (!isEmpty(res)) {
        res.forEach((e) => {
          e.items.forEach((item) => {
            if (item.selected === 1) productChoice = true;
          });
        });
      }
    });

    if (
      isEmpty(checkuserinfo) ||
      isEmpty(questions) ||
      isEmpty(pageAgree) ||
      pageAgree.termandcon !== 1 ||
      pageAgree.pdpa !== 1 ||
      isEmpty(snapIdCard) ||
      isEmpty(idc) ||
      isEmpty(idcAddr) ||
      isEmpty(curAddr) ||
      isEmpty(workAddr) ||
      isEmpty(docAddr) ||
      isEmpty(career) ||
      !productChoice ||
      isEmpty(suit) ||
      isEmpty(status) ||
      isEmpty(childList?.data) ||
      isEmpty(income) ||
      isEmpty(purpose) ||
      isEmpty(asset) ||
      isEmpty(uploadImgSign) ||
      isEmpty(ats) ||
      isEmpty(bank_ats) ||
      (isEmpty(uploadImageBookBank) && ats.f7_isother === "1") ||
      (stamp_page !== "NDID" && stamp_page !== "CONFIRM")
    ) {
      return true;
    } else {
      return false;
    }
  };
  const getImage = async () => {
    setIsLoading(true);
    var postData = {
      head_token,
    };
    const header = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const queryString = new URLSearchParams(postData).toString();
    let getImage_url = `${Configs.baseURL}/api/getupload?` + queryString;
    try {
      await GlobalApi.get(getImage_url, header)
        .then(async (res) => {
          setIsLoading(false);
          if (res.data.api_status === "1") {
            if (res.data.data.length > 0) {
              res.data.data.forEach((element) => {
                if (element.tb_image_page === "uploadImage") {
                  snapIdCard = element.tb_image_type + element.tb_image_base64;
                } else if (element.tb_image_page === "eSignature") {
                  uploadImgSign =
                    element.tb_image_type + element.tb_image_base64;
                } else if (element.tb_image_page === "eSignature") {
                  uploadImgSign =
                    element.tb_image_type + element.tb_image_base64;
                } else if (element.tb_image_page === "uploadImageBookBank") {
                  uploadImageBookBank =
                    element.tb_image_type + element.tb_image_base64;
                }
              });
            }
          }
        })
        .catch((er) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
    return;
  };
  const handleNext = async () => {
    const card_id = checkuserinfo?.cardId;
    setIsLoading(true);
    if (card_id === "" || card_id === null || card_id === undefined) {
      setIsModalError(true);
      setModalErrorTitle("ไม่สามารถทำรายการได้");
      setModalErrorDes("เลขบัตรประชาชนไม่ถูกต้อง");
      setIsLoading(false);
    } else {
      await GlobalApi.get(
        `${Configs.baseAPIURL03}/form/ndid2/quota?identifier=${card_id}`,
      )
        .then((res) => {
          setIsLoading(false);
          const { limit, total } = res.data.data;
          if (total < limit) {
            props.history.push("/ndid_condition");
          } else {
            setModalErrorTitle("ไม่สามารถดำเนินการต่อได้");
            setModalErrorDes(
              "เนื่องจากท่านทำรายการเปลี่ยนธนาคาร<br/>เกินกว่าจำนวนที่บริษัทกำหนด<br/>กรุณาติดต่อ DAOL Contact Center<br/>0 2351 1800",
            );
            setIsModalError(true);
          }
        })
        .catch((er) => {
          setIsLoading(false);
          setModalErrorTitle("ไม่สามารถทำรายการได้");
          setModalErrorDes("กรุณาติดต่อ DAOL Contact Center<br/>0 2351 1800");
          setIsModalError(true);
        });
    }
  };
  const saveComeback = async (type) => {
    storeData("stamp_page", type);
    var last_stamp = JSON.stringify(await getAllStorage(type));

    const saveData = [
      {
        name: "comeback",
        url: `${Configs.baseAPIURL03}/form/comeback/manp`,
        postData: {
          head_token: head_token,
          last_stamp: last_stamp,
          stamp_page: type,
        },
      },
    ];
    setIsLoading(true);
    try {
      await GlobalApi.post(
        saveData[0].url,
        qs.stringify(saveData[0].postData),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json",
          },
        },
      )
        .then((res) => {
          setIsLoading(false);
          if (res?.data?.Data?.[0]?.[0]?.IsSuccess !== 1) {
            let mss =
              res.data.Data[0].MsgDesc !== ""
                ? res.data.Data[0].MsgDesc
                : "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";
            let title = "เกิดข้อผิดพลาด";
            setIsLoading(false);
            setIsModalError(true);
            setModalErrorTitle(title);
            setModalErrorDes(mss);
          } else {
            type == "EKYC"
              ? props.history.push("/ekyc")
              : props.history.push("/summary");
          }
        })
        .catch((er) => {
          console.log(er);

          setIsLoading(false);
          let title = "เกิดข้อผิดพลาด";
          let mss =
            "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" +
            getData("api_error")?.message +
            ")";
          setIsModalError(true);
          setModalErrorTitle(title);
          setModalErrorDes(mss);
        });
    } catch (error) {
      console.log(error);

      setIsLoading(false);
      setIsModalError(true);
    }
  };
  return (
    <>
      {jumpPage ? (
        <Grid className="app-splash-screen"></Grid>
      ) : (
        <>
          <HeaderPage
            title={translations?.[lang]?.ndid?.title}
            onChangeLang={(e) => setLang(e)}
            clickBack={(e) =>
              e ? saveComeback(ic?.AECode ? "EKYC" : "SUMMARY") : ""
            }
          />
          <Loading status={isLoading} />
          <DialogError
            open={isModalError}
            isModel={setIsModalError}
            title={modalErrorTitle}
            massage={modalErrorDes}
            btn={"ตกลง"}
          />
          <Grid className="background-bg">
            <Grid className="section-consent">
              <Grid className={isMobile ? "box-content-mb" : "box-content"}>
                <Grid container className="box-content-main" columns={16}>
                  {!isMobile && (
                    <Grid item xs={7} className="box-left">
                      <BoxLeftContent
                        translations={translations?.[lang]?.ndid}
                        clickBack={(e) =>
                          e ? saveComeback(ic?.AECode ? "EKYC" : "SUMMARY") : ""
                        }
                      />
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={isMobile ? 16 : 9}
                    className={isMobile ? "box-right-mb" : "box-right"}
                  >
                    <Grid className="content">
                      <Grid className="content-main">
                        <Grid
                          className="box-right-content pb-3"
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            height: "100%",
                          }}
                        >
                          {!isMobile && (
                            <HeaderRight
                              ndid
                              title={translations?.[lang]?.ndid?.title}
                            />
                          )}
                          <ScrollBarComponent
                            isCheck={isCheck}
                            onChangeCheck={setIscheck}
                            content={
                              <Box>
                                <Grid
                                  className={clsx(
                                    "font-title text-center font-DBHeavent font-weight-bold font-20",
                                  )}
                                  dangerouslySetInnerHTML={{
                                    __html:
                                      "กรุณาตรวจสอบว่าท่านผ่านการดำเนินการ<br/>ด้านล่างเรียบร้อยแล้ว",
                                  }}
                                  sx={{
                                    fontSize: "22px",
                                    pt:2
                                  }}
                                />

                                <Grid className="py-4">
                                  <Box
                                    className={clsx(
                                      classes.ndidTable,
                                      isMobile && "pt-15",
                                    )}
                                  >
                                    <Box>
                                      <CardMedia
                                        component="img"
                                        image="images/Asset1.png"
                                      />
                                    </Box>
                                    <Box className="font-20 text-primary">
                                      ผ่านการเสียบบัตรประชาชนและ
                                      ถ่ายรูปผ่านช่องทางธนาคาร
                                    </Box>
                                  </Box>
                                  <Box
                                    className={clsx(
                                      classes.ndidTable,
                                      isMobile && "pt-10",
                                    )}
                                  >
                                    <Box>
                                      <CardMedia
                                        component="img"
                                        image="images/Asset3.png"
                                      />
                                    </Box>

                                    <Box className="font-20 text-primary">
                                      ลงทะเบียน NDID กับแอปพลิเคชัน K Plus, KMA,
                                      Bualuang mBanking, MyMo, CIMB TH
                                      หรือลงทะเบียนที่สาขาของธนาคารไทยพานิชย์
                                      เกียรตินาคินภัทร หรือทีเอ็มบีธนชาต
                                    </Box>
                                  </Box>
                                </Grid>
                              </Box>
                            }
                          ></ScrollBarComponent>
                          <ButtonRight
                            text={translations?.[lang]?.ndid?.next}
                            onNextPage={handleNext}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};

export default memo(NdidInformation);
